export enum MarginType 
{
    CostPlus = 0,
    RetailMinus = 1,
    FlatFee = 2,
    Inactive = 3
}